import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { Table, DatePicker, Button, Popover } from 'antd';
import ExportUtil from '../../../common/ExportUtil';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import MainContent from './MainContent';
import TopInfo from '../../basicElement/TopInfo';
import moment from 'moment';
import '../style/home.less';

const monthFormat = 'YYYY-MM';
const { MonthPicker } = DatePicker;

class Filter extends Component {
    constructor(props) {
        super(props);
        const { searchParams } = this.props;
        this.state = {
            searchParams: {...searchParams},
        }
    }

    search = () => {
        const { params = {}, searchParams } = this.state;
        this.props.search({...searchParams, ...params});
    }

    export = () => {
        this.props.export();
    }

    handleBeignMonth = (date, dateString) => {
        const { searchParams } = this.state;
        searchParams.startDate = dateString
        this.setState({ searchParams });
    }

    handleEndMonth = (date, dateString) => {
        const { searchParams } = this.state;
        searchParams.endDate = dateString
        this.setState({ searchParams });
    }

    disabledDate = (current) => {
        const { maxDate } = this.props;
        const value = moment(maxDate).valueOf();
        return current && current.valueOf() > value;
    }

    render () {
        const { searchParams: { startDate, endDate }} = this.state;
        const begin = startDate ? moment(startDate) : null;
        const end = endDate ? moment(endDate) : null;
        const { positionRole } = sessionStorage;
        return (
            <div className="filter-bar bar2" style={{ marginTop: 10 }}>
                <div className="form-item">
                    <label className="ui-label">时间</label>
                    <MonthPicker
                        format={monthFormat}
                        onChange={this.handleBeignMonth}
                        allowClear={false}
                        value={begin}
                        disabledDate={this.disabledDate}
                    />
                </div>
                <div className="form-item">
                    <label className="ui-label">至</label>
                    <MonthPicker
                        format={monthFormat}
                        onChange={this.handleEndMonth}
                        allowClear={false}
                        value={end}
                        disabledDate={this.disabledDate}
                    />
                </div>
                <div className="form-item">
                    { positionRole !== 'CRC' && <Button type="primary" onClick={this.export}>导出</Button> }
                    <Button type="primary" onClick={this.search}>搜索</Button>
                </div>
            </div>
        )
    }
}

class SsuPerformanceDetail extends Component {
    constructor(props) {
        super(props);
        const { performanceState } = this.props;
        const { params = {}, maxDate } = performanceState;
        const { startDate, endDate } = params;
        this.state = {
            searchParams: {
                startDate,
                endDate,
            },
            maxDate,
            performanceState: {
                ...performanceState,
                params: {...params},
            },
            loading: false,
            cur: 'main',
            list: [],
            ssuPerformanceEfficient: {},
            performanceMinusScores: [],
            performanceAddScores: [],
            ssuPerformanceSpeed: [],
            performanceScores: [],
            ssuPerformanceTask: [],
        };
    }
    
    componentDidMount() {
        const { searchParams: { startDate, endDate } } = this.state;
        startDate && endDate && this.loadData();
    }

    loadData = () => {
        const { searchParams, performanceState: { params, userId = '' } } = this.state;
        const { areaParams = {} } = params;

        this.setState({ loading: true });
        const queryData = {
            ...params,
            ...searchParams,
            ...areaParams,
            userId,
        };
        delete queryData.areaParams;
        delete queryData.hasCheckedArea;
        const options = {
            method: 'POST',
            url: API_URL.home.queryPerformanceSsuUserScoreDetail,
            data: queryData,
            dataType: 'json',
            doneResult: res => {
                const {
                    performanceScores = [],
                    performanceMinusScores = [],
                    performanceAddScores = [],
                    ssuPerformanceEfficient = {},
                    ssuPerformanceSpeed = [],
                    ssuPerformanceTask = [],
                    userScore = [],
                } = res;
                this.setState({
                    ssuPerformanceEfficient,
                    performanceMinusScores,
                    performanceAddScores,
                    ssuPerformanceSpeed,
                    performanceScores,
                    ssuPerformanceTask,
                    loading: false,
                    list: userScore,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        }
        $.sendRequest(options)
    }

    search = (params) => {
        const { searchParams: { startDate, endDate }, performanceState } = this.state;
        if ((startDate != params.startDate) || (endDate != params.endDate)) {
            performanceState.params = {};
        }
        this.setState({
            performanceState,
            searchParams: {...params}
        }, () => {
            this.loadData();
        })
    }

    export = () => {
        const { searchParams, performanceState: { params = {}, userId = '' } } = this.state;
        const url = API_URL.home.exportPerformanceSsuUserScore;
        const { areaParams } = params;
        const exportParams = {
            ...searchParams,
            ...areaParams,
            ...params,
            userId,
            type: 'performanceSSUUserScoreDetail',
        };
        delete exportParams.areaParams;
        delete exportParams.hasCheckedArea;
        ExportUtil.export(exportParams, null, url);
    }

    getColumns = () => ([
        {
            title: '排名',
            dataIndex: 'rank',
            key: 'rank',
            width: 85,
            render: text => {
                const {
                    searchParams: {
                        startDate,
                        endDate,
                    },
                    performanceState: {
                        params,
                    }
                } = this.state;
                const { areaName, positionName } = params;
                return (
                    <div>
                        <Popover
                            placement="top"
                            overlayClassName="contract-pop"
                            content={<div>
                                {<strong>排名统计条件:<br/></strong>}
                                {<span>时间: {startDate}~{endDate} <br/></span>}
                                {<span>区域/城市: {areaName} <br/></span>}
                                {<span>职位级别: {positionName} <br/></span>}
                            </div>}
                            trigger="hover"
                        >
                            <i className='pop' style={{cursor: 'pointer'}}></i>
                        </Popover>
                        <div className='pop-div'>{text}</div>
                    </div>
                )
            }
        }, {
            title: 'SSU姓名',
            dataIndex: 'userCompellation',
            key: 'userCompellation',
            width: 95,
        }, {
            title: 'SSU工号',
            dataIndex: 'employeeCode',
            key: 'employeeCode',
            width: 95,
        }, {
            title: '职位级别',
            dataIndex: 'positionName',
            key: 'positionName',
            width: 115,
        }, {
            title: '区域',
            dataIndex: 'areaName',
            key: 'areaName',
            width: 95,
        }, {
            title: '城市',
            dataIndex: 'workCityName',
            key: 'workCityName',
            width: 95,
        },  {
            title: '主管姓名',
            dataIndex: 'leaderUserCompellation',
            key: 'leaderUserCompellation',
            width: 95,
        },  {
            title: '主管工号',
            dataIndex: 'leaderEmployeeCode',
            key: 'leaderEmployeeCode',
            width: 95,
        }, {
            title: '总分',
            dataIndex: 'trueTotalPoint',
            key: 'trueTotalPoint',
            width: 90,
        }, {
            title: '主要业绩分',
            dataIndex: 'mainAchievementPoint',
            key: 'mainAchievementPoint',
            width: 90,
        }, {
            title: '加分',
            dataIndex: 'bonusPoint',
            key: 'bonusPoint',
            width: 90,
        }, {
            title: '减分',
            dataIndex: 'minusPoint',
            key: 'minusPoint',
            width: 90,
        },
    ])

    getDataSource = () => {
        const { list } = this.state;
        const dataSource = list.map((item, index) => (
            {
                index: index + 1,
                ...item,
            }
        ));
        return dataSource;
    }

    getStrongRender = (text, record) => {
        if (record.performanceScoreName.startsWith('合计')) {
            return <strong>{text}</strong>;
        }
        return text;
    }

    getPlusColumns = () => ([
        {
            title: '考核项',
            dataIndex: 'performanceScoreName',
            render: this.getStrongRender,
        }, {
            title: '得分',
            dataIndex: 'scoreValue',
            render: this.getStrongRender,
        }
    ])

    getPlusDataSource = () => {
        const { performanceAddScores = [] } = this.state;
        const dataSource = performanceAddScores.map((item, index) => {
            return {
                index: index + 1,
                ...item,
            }
        });
        return dataSource;
    }

    getReduceColumns = () => ([
        {
            title: '考核项',
            dataIndex: 'performanceScoreName',
            render: this.getStrongRender,
        }, {
            title: '得分',
            dataIndex: 'scoreValue',
            render: this.getStrongRender,
        }
    ])

    getReduceDataSource = () => {
        const { performanceMinusScores = [] } = this.state;
        const dataSource = performanceMinusScores.map((item, index) => {
            return {
                index: index + 1,
                ...item,
            }
        });
        return dataSource;
    }

    changeCur = (cur) => {
        this.setState({ cur });
    }

    render() {
        const {
            cur,
            loading,
            performanceState: {
                userCompellation = '',
                employeeCode = '',
            },
            searchParams: {
                startDate,
                endDate
            },
            performanceScores = [],
            ssuPerformanceTask = [],
            ssuPerformanceSpeed = [],
            ssuPerformanceEfficient = {},
            searchParams,
            maxDate,
        } = this.state;
        if (!startDate || !endDate) {
            return <Redirect to="/home" />;
        }
        return (
            <div className="container">
                <div className="full work_flow">
                    <TopInfo title={`SSU绩效排行-${userCompellation}[${employeeCode}]`} onClick={() => history.go(-1)} />
                    <Filter
                        maxDate={maxDate}
                        search={this.search}
                        export={this.export}
                        searchParams={searchParams}
                    />
                    <Table
                        bordered
                        loading={loading}
                        scroll={{x: 1130}}
                        pagination={false}
                        columns={this.getColumns()}
                        dataSource={this.getDataSource()}
                        rowKey={record => record.index}
                    />
                    <div className="home" style={{ marginTop: 16, borderTop: '1px solid #d1d1d1' }}>
                        <div className="change-btn" style={{ margin: '24px auto', width: 1100 }}>
                            <a className={cur == 'main' && "cur"} onClick={() => this.changeCur('main')}>主要业绩</a>
                            <a className={cur == 'plus' && "cur"} onClick={() => this.changeCur('plus')}>加分</a>
                            <a className={cur == 'reduce' && "cur"} onClick={() => this.changeCur('reduce')}>减分</a>
                        </div>
                        {
                            cur == 'main' ?
                                <MainContent
                                    loading={loading}
                                    performanceScores={performanceScores}
                                    ssuPerformanceTask={ssuPerformanceTask}
                                    ssuPerformanceSpeed={ssuPerformanceSpeed}
                                    ssuPerformanceEfficient={ssuPerformanceEfficient}
                                />
                            : ( cur == 'plus' ?
                                    <Table
                                        bordered
                                        loading={loading}
                                        scroll={{x: 1130}}
                                        pagination={false}
                                        columns={this.getPlusColumns()}
                                        dataSource={this.getPlusDataSource()}
                                        rowKey={record => record.index}
                                    />
                                :
                                    <Table
                                        bordered
                                        loading={loading}
                                        scroll={{x: 1130}}
                                        pagination={false}
                                        columns={this.getReduceColumns()}
                                        dataSource={this.getReduceDataSource()}
                                        rowKey={record => record.index}
                                    />
                            )
                        }
                    </div>
                </div>
            </div>
        )
    }
}

const mapSateToProps = (state) => ({
    performanceState: state.rankState.params || {},
});

export default connect(mapSateToProps, null)(SsuPerformanceDetail);


// WEBPACK FOOTER //
// ./src/components/home/ssuPerformanceDetail/index.js